// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__yeQuu","checkBoxOld":"styles_checkBoxOld__g79ND","checkBox":"styles_checkBox__2Md7f","button":"styles_button__WZzbi","inputs":"styles_inputs__3Mv3e"};